import apisauce from "apisauce";
import AppConfig from "Config/AppConfig";

// ------------ Auxillary Functions ------------ //

const authPrefix = "Bearer";

const create = (baseURL = AppConfig.APIServer) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      Accept: "*/*"
    },
    timeout: 10000
  });

  // ------------ Your API calls ------------ //

  const updateFeed = () => {
    api.deleteHeader("Authorization");
    return api.get("projects/update-feed/");
  };

  const updateDetail = ({ token, data }) => {
    if (token) {
      api.setHeader("Authorization", `${authPrefix} ${token}`);
    } else {
      api.deleteHeader("Authorization");
    }
    return api.get(`projects/update/${data}/`);
  };

  const submitRating = ({ token, data }) => {
    const { id, rating } = data;
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`projects/update-rating/${id}/`, { rating });
  };

  const exploreProjects = () => {
    api.deleteHeader("Authorization");
    return api.get("projects/explore/");
  };

  const createProject = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("projects/explore/", {
      ...data
    });
  };

  const addResources = ({ token, data: { values, project } }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`projects/resources/${project}/`, {
      resources: values
    });
  };

  const getProjectDetails = id => {
    api.deleteHeader("Authorization");
    return api.get(`projects/detail/${id}/`);
  };

  const deleteProject = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.delete(`projects/detail/${data}/`);
  };

  const getProjectResources = id => {
    api.deleteHeader("Authorization");
    return api.get(`projects/detail/${id}/resources/`);
  };

  const getProjectLeader = id => {
    api.deleteHeader("Authorization");
    return api.get(`projects/leader/${id}`);
  };

  const getProjectMembers = id => {
    api.deleteHeader("Authorization");
    return api.get(`projects/detail/${id}/members/`);
  };

  const joinProject = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post(`projects/join-project/${data}/`);
  };

  const getJoinProjects = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get(`projects/join-project/`);
  };

  const getUserProjects = data => {
    return api.get(`projects/user-projects/${data}`);
  };

  const getResources = () => {
    api.deleteHeader("Authorization");
    return api.get("projects/resources/");
  };

  const updateProjectDetails = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`projects/detail/${data.id}/`, {
      project_name: data.projectName,
      project_description: data.projectDescription
    });
  };

  const getComments = data => {
    api.deleteHeader("Authorization");
    return api.get(`projects/comments/${data}`);
  };

  const postComment = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post(`projects/comments/${data.id}/`, {
      comment: data.comment
    });
  };

  const getProjectImages = data => {
    api.deleteHeader("Authorization");
    return api.get(`projects/images/${data}`);
  };

  const addProjectImage = ({ token, data }) => {
    const { id, image } = data;
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post(`projects/images/${id}`, {
      image
    });
  };

  const deleteProjectImage = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.delete(`projects/images/${data}`);
  };

  const updateProjectIcon = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`projects/icon/${data.id}/`, {
      project_icon: data.projectIcon
    });
  };

  const updateProjectAvatar = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`projects/avatar/${data.id}/`, {
      image: data.image
    });
  };

  const createProjectUpdate = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post(`projects/project-update/${data.id}/`, {
      update: data.update,
      update_details: data.updateDescription
    });
  };

  const getProjectUpdates = ({ token, data }) => {
    return api.get(`projects/project-update/${data}`);
  };

  const deleteProjectUpdate = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.delete(`projects/project-update/${data}/`);
  };

  const saveProject = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`projects/edit-project/${data.id}/`, {
      color: data.color
    });
  };

  // ------------ Return all APIs ------------ //

  return {
    updateFeed,
    updateDetail,
    exploreProjects,
    getProjectDetails,
    getProjectLeader,
    getProjectResources,
    getProjectMembers,
    joinProject,
    getJoinProjects,
    getUserProjects,
    createProject,
    getResources,
    addResources,
    deleteProject,
    updateProjectDetails,
    getComments,
    postComment,
    getProjectImages,
    updateProjectIcon,
    createProjectUpdate,
    getProjectUpdates,
    deleteProjectUpdate,
    addProjectImage,
    deleteProjectImage,
    updateProjectAvatar,
    saveProject,
    submitRating
  };
};

// ------------ Main Export ------------ //

export default {
  create
};
